import { ChangeDetectionStrategy, Component } from "@angular/core";
import { RouterOutlet } from "@angular/router";

/** Bare layout for auth pages (sign-in / password-reset / sign-out) — no shell chrome. */
@Component({
    selector: "empty-layout",
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterOutlet],
    // Host must grow to fill app-root (a flex row); without this it shrinks to
    // content width and auth pages (bg + card) get squeezed into a left column.
    host: { class: "flex flex-auto w-full" },
    templateUrl: './empty-layout.component.html',
})
export class EmptyLayoutComponent {}
